import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";

const DisputeReasonModal = ({ open, loading, period, onCancel, onSubmit }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }

        form.setFieldsValue({ reason: period?.remarks || undefined });
    }, [form, open, period]);

    const handleOk = async () => {
        const values = await form.validateFields();
        await onSubmit(values.reason);
    };

    return (
        <Modal
            title="标记价格异常"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
            width={460}
            destroyOnClose
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                <Form.Item name="reason" label="异常原因">
                    <Input.TextArea rows={4} placeholder="请输入异常原因（可选）" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default DisputeReasonModal;
